import { ReactQueryDevtools } from './ReactQueryDevtools.js';
import { ReactQueryDevtoolsPanel } from './ReactQueryDevtoolsPanel.js';

var ReactQueryDevtools2=process.env.NODE_ENV!=="development"?function(){return null}:ReactQueryDevtools;process.env.NODE_ENV!=="development"?function(){return null}:ReactQueryDevtoolsPanel;

export { ReactQueryDevtools2 as ReactQueryDevtools };
//# sourceMappingURL=index.js.map
